import { render, staticRenderFns } from "./AlertBanner.vue?vue&type=template&id=49c11574&"
import script from "./AlertBanner.vue?vue&type=script&lang=js&"
export * from "./AlertBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSystemBar } from 'vuetify/lib/components/VSystemBar';
installComponents(component, {VSystemBar})
